module.exports = __webpack_public_path__ + "img/mind_template_item_1_2.9b6963c2.png";